/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_NowInputs */

const en_apply_now = /** @type {(inputs: Apply_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply now`)
};

const de_apply_now = /** @type {(inputs: Apply_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt bewerben`)
};

/**
* | output |
* | --- |
* | "Apply now" |
*
* @param {Apply_NowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const apply_now = /** @type {((inputs?: Apply_NowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_NowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_apply_now(inputs)
	return en_apply_now(inputs)
});